import { render, staticRenderFns } from "./CompanyLeaveAssignmentPage.vue?vue&type=template&id=f3f61edc&scoped=true&"
import script from "./CompanyLeaveAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./CompanyLeaveAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f61edc",
  null
  
)

export default component.exports